import { NavBar } from './NavBar'
import { TopBar } from './TopBar'
import s from './AppHeader.module.css'

/**
 * Шапка целиком: верхний ярус (компании, поиск, уведомления, профиль) и нижний (навигация).
 *
 * `<header>` объявлен здесь, а не внутри ярусов: landmark `banner` должен быть один. Обёртка
 * не декоративная — она же липкий контейнер обоих ярусов, почему один, а не два, объяснено
 * в `AppHeader.module.css`.
 */
export function AppHeader() {
  return (
    <header className={s.root}>
      <TopBar />
      <NavBar />
    </header>
  )
}
